var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c(_setup.indexPage,{attrs:{"parentData":_setup.parentData},on:{"set-loading":_setup.setLoading}}),_c(_setup.uiPrompts,{attrs:{"parentData":{ areas_key: _setup.grid }}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }